<template>
    <div class="flex xs:flex-wrap sm:flex-no-wrap gap-x-2 xs:gap-y-2">
        <v-popover
            v-for="button in buttons" :key="button.key"
            :disabled="button.disabled"
            :open.sync="button.opened"
            offset="16" class="flex-1 w-full"
            >
            <PaymentButton
                :selected="button.selected && !button.disabled"
                :hotKey="button.hotKey"
                :imgSelected="button.imgSelected"
                :imgNotSelected="button.imgNotSelected"
                :label="button.label"
                :disabled="button.disabled"
                :helpKey="button.helpKey"
                flat
                class="tooltip-target"
                @click="setSelection(button)"
                @shortkey="toogleSelection(button)"
            />

            <template slot="popover">
               <component :is="button.innerComponent"
                    v-model="button.selected"
                    @closePanel="() => buttonsData[button.key].opened = false"
                    :totalValue="totalValue"
                    :leftToPay="leftToPay"
                    :bill="bill"
                    v-show="button.opened"/>
            </template>
        </v-popover>

         <slot name="after"/>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import PaymentButton from './PaymentButton.vue'
    import DiscountPanel from './panels/DiscountPanel';
    import TaxesPanel from './panels/TaxesPanel';
    import NfcePanel from './panels/NfcePanel';

    export default {
        components: {
            PaymentButton,
            DiscountPanel,
            TaxesPanel,
            NfcePanel 
        },
        props: {
            totalValue: Number,
            leftToPay: Number,
            bill: Object,
            canSendNfce: Boolean
        },

        data() {
            return {
                buttonsData: {
                    taxes: {
                        key : 'taxes',
                        label : 'Taxas',
                        opened: false,
                        hotKey: ['alt', 'c'],
                        selected: false,
                        imgSelected : require('@/assets/images/payment/calculator_white.png'),
                        imgNotSelected : require('@/assets/images/payment/calculator.png'),
                        innerComponent: 'TaxesPanel'
                    },
                    discount: {
                        key : 'discount',
                        label : 'Descontos',
                        opened: false,
                        hotKey: ['alt', 'd'],
                        selected: false,
                        imgSelected : require('@/assets/images/payment/discount_white.png'),
                        imgNotSelected : require('@/assets/images/payment/discount.png'),
                        innerComponent: 'DiscountPanel'
                    },
                    nfce: {
                        key : 'nfce',
                        label : 'NFCe',
                        opened: false,
                        hotKey: ['alt', 'n'],
                        selected: false,
                        imgSelected : require('@/assets/images/payment/receipt_white.png'),
                        imgNotSelected : require('@/assets/images/payment/receipt.png'),
                        innerComponent: 'NfcePanel',
                    },
                }
            }
        },
        computed : {
            buttons () {
                const { nfce, discount, taxes } = this.buttonsData;
                this.$set(nfce, 'disabled', !this.canSendNfce);
                this.$set(taxes, 'disabled', taxes.selected && !this.canSetTaxes);
                return Object.values({ taxes, discount });
            },
            canSetTaxes () {
                return this.leftToPay >= (this.bill.value / 10);
            },
            ...mapState('payment', ['discount'])
        },

        methods : {
            setSelection (button) {
                this.buttonsData[button.key].selected = true;
            },
            toogleSelection (button) {
                this.buttonsData[button.key].selected = !button.selected;
                this.buttonsData[button.key] = button.selected;
            }
        }
    }
</script>

<style>
    .notSelected {
        opacity: 0.6;
    }
    .btn-big {
        border-radius: 6px;
        -webkit-transition: all .2s linear;
        transition: all .2s linear;
    }
    .selected-btn {
        background-color: #EA5455;
    }

</style>
<style lang="sass">
// todo set as scoped
.tooltip
  &.popover
    $color: #f9f9f9;
    z-index: 9999999
    border: 1px #CCC solid
    border-radius: 5px;

    .popover-inner
      background: $color;
      color: black;
      padding: 12px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .35);

.trigger
    display: inherit !important
</style>